export default __webpack_public_path__ + "static/media/avi-packer.f24d151f.png";